<template>
    <v-container>
        <v-row class="center">
            <v-card id="dash-graph" class="graph-card px-3 col-11">
                <h3>Business Traffic for {{ currentMonth }}</h3>
                <v-row dense>
                    <v-col style="min-width: 200px;" cols="3" dense>
                        <v-select dense color="#00006d" v-model="currentTerm" item-text="label" item-value="key"
                            :items="availableTerms" label="Term" outlined></v-select>
                    </v-col>
                </v-row>
                <v-row class="data-label" dense v-if="currentMonthsTraffic">
                    <v-col cols="2">{{ currentMonthsTraffic[0] }}</v-col>
                    <v-col v-if="currentMonthsTraffic.length >= 2" cols="2">{{
                        currentMonthsTraffic[Math.ceil(currentMonthsTraffic.length / 2)] }}</v-col>
                    <v-col v-if="currentMonthsTraffic.length >= 3" cols="2">{{
                        currentMonthsTraffic[currentMonthsTraffic.length - 1] }}</v-col>
                </v-row>
                <v-sparkline v-if="currentMonthsTraffic" auto-draw :show-labels="true" label-size="5" line-width="2"
                    padding="15" stroke-linecap="round" :gradient="gradients" :labels="labelDays"
                    :value="currentMonthsTraffic">
                </v-sparkline>
                <div v-else class="empty-graph center">
                    <v-col cols="4">
                        <v-row class="center">No Monthly Trend Data</v-row>
                        <v-row class="center">Check Back Tomorrow</v-row>
                    </v-col>
                </div>
                <v-divider></v-divider>
                <v-row class="center py-5">
                    <site-button v-if="menuLink" :colNum="3" :marginNumber="2" btnType="text" text="View Menu"
                        iconType="SVG" colorClasses="secondary-icon" iconColor="primary-icon" :iconString="menuIcon"
                        @click-event="toggleMenuDialog"></site-button>

                    <site-button v-else :colNum="3" :marginNumber="2" btnType="text" text="Upload Menu" iconType="SVG"
                        colorClasses="secondary-icon" iconColor="primary-icon" :iconString="menuIcon"
                        @click-event="addMenu"></site-button>

                    <site-button :colNum="3" :marginNumber="2" btnType="text" text="Foodie Photos" iconType="SVG"
                        colorClasses="secondary-icon" iconColor="primary-icon" :iconString="foodiePhotosIcon"
                        @click-event="foodiePhotos"></site-button>

                    <site-button :colNum="3" :marginNumber="2" btnType="text" text="Show N Go Promos" iconType="SVG"
                        colorClasses="secondary-color" iconColor="primary-icon" :iconString="showNGoPromosIcon"
                        @click-event="promoNav"></site-button>
                </v-row>
                <input style="display: none;" type="file" ref="menu-file-input" id="menu-file-input"
                    accept="application/pdf" @change="uploadMenu($event)" />
            </v-card>
        </v-row>
        <menu-dialog v-on:setDialogControl="toggleMenuDialog" :menuURL="menuLink" v-on:delete-link="deleteMenu"
            title="View Menu" v-on:switch-link="addMenu" :showDialog="showMenuDialog"></menu-dialog>
        <v-dialog width="35%" persistent v-model="isLoading">
            <loader-card :title="loaderTitle"></loader-card>
        </v-dialog>
    </v-container>
</template>

<style scoped>
.data-label {
    justify-content: space-between;
}

.empty-graph {
    height: 50%;
    position: relative;
}
</style>

<script>
import utils from "../../utilities/utils";
import HoverButton from "../../components/common/SiteButton";
import MenuDocDialog from "../../components/common/MenuDocDialog";
import LoaderDialogCard from "../../components/common/LoaderDialogCard";
import { MongoMixins } from '../../mixins/mongo-mixins';
import moment from "moment";

export default {
    name: 'business-dash',
    components: {
        "site-button": HoverButton,
        "menu-dialog": MenuDocDialog,
        "loader-card": LoaderDialogCard
    },
    mixins: [MongoMixins],
    data: () => ({
        gradients: ['#00006d', '#EE1D00'],
        showMenuDialog: false,
        isLoading: false,
        loaderTitle: '',
        currentTerm: moment().toISOString().substring(0, 7)
    }),
    methods: {
        promoNav() {
            this.$router.push('group-deals');
        },
        addMenu() {
            this.$refs['menu-file-input'].click();
        },
        foodiePhotos() {
            this.$router.push('foodie-photos');
        },
        deleteMenu() {
            this.deleteBusinessMenu(this.$store.getters.partnerId).then(() => {
                this.showMenuDialog = false;
                this.$store.dispatch('UPDATE_MENU', null);
            })
        },
        toggleMenuDialog(newVal) {
            console.log('toggle: ' + newVal)
            if (!newVal) {
                this.showMenuDialog = !this.showMenuDialog;
            } else {
                this.showMenuDialog = newVal;
            }
        },
        async uploadMenu(event) {
            console.log('upload');
            this.isLoading = true;
            this.loaderTitle = 'Uploading Menu';
            if (!!event.target.files && event.target.files.length > 0) {
                this.submitBusinessMenu(this.$store.getters.partnerId, event.target.files[0]).then((res) => {
                    this.$store.dispatch('UPDATE_MENU', res.data.link);
                    this.loaderTitle = 'Upload Complete';
                    setTimeout(() => {
                        this.isLoading = false;
                        this.loaderTitle = '';
                    }, 2000)
                }).catch(() => {
                    this.loaderTitle = 'Upload Error';
                    setTimeout(() => {
                        this.isLoading = false;
                        this.loaderTitle = '';
                    }, 2000)
                });
            } else {
                this.loaderTitle = 'Upload Cancelled';
                setTimeout(() => {
                    this.isLoading = false;
                })
                console.log('cancled')
            }
        }
    },
    computed: {
        foodiePhotosIcon() {
            return require('../../assets/Foodie-Photos-Icon.svg');
        },
        showNGoPromosIcon() {
            return require('../../assets/Show-N-Go-Icon-Prim.svg');
        },
        menuIcon() {
            return require('../../assets/Menu-Icon.svg');
        },
        cardMargin() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return 'mx-12'
                case 'sm':
                    return 'mx-12'
                case 'md':
                    return 'mx-6'
                case 'lg':
                    return 'mx-6'
                case 'xl':
                    return 'mx-6'
                default:
                    return 'mx-6'
            }
        },
        cardClass() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return 'col-4'
                case 'sm':
                    return 'col-4'
                case 'md':
                    return 'col-3'
                case 'lg':
                    return 'col-3'
                case 'xl':
                    return 'col-3'
                default:
                    return 'col-3'
            }
        },
        businessTraffic() {
            return this.$store.getters.businessTraffic;
        },
        businessData() {
            return this.$store.state.partnerData;
        },
        menuLink() {
            return this.$store.state.partnerData.menuLink;
        },
        availableTerms() {
            const terms = [...new Set(this.$store.getters.businessTraffic.views.map(v => v.term))],
                termLabels = [];
            console.log('terms ', terms);
            for (let i = 0; i < terms.length; i++) {
                const termSplit = terms[i].split('-');
                termLabels.push({ key: terms[i], label: moment().month(parseInt(termSplit[1]) - 1).year(termSplit[0]).format('MMMM YYYY') });
            }
            console.log('labels ', termLabels);
            return termLabels;
        },
        currentMonthsTraffic() {
            try {
                const traffic = this.$store.getters.businessTraffic.views.filter(item => {
                    return item.term === this.currentTerm;
                });

                console.log(traffic);

                if (!traffic || traffic.length === 0) {
                    return null;
                } else if (traffic[0].day !== 1) {
                    return [0, ...traffic.map(s => s.traffic)];
                } else {
                    return traffic.map(s => s.traffic);
                }
            } catch (e) {
                return null;
            }
        },
        labelDays() {
            try {
                const data = this.$store.getters.businessTraffic.views.filter(item => {
                    return item.term === this.currentTerm;
                });

                if (data && data.length > 0) {
                    return utils.getDaysWithData(this.currentTerm, data)
                } else {
                    return null;
                }
            } catch (e) {
                return null;
            }
        },
        currentMonth() {
            const termSplit = this.currentTerm.split('-');
            if (termSplit.length == 2) {
                const calcDate = moment().month(parseInt(termSplit[1]) - 1).year(termSplit[0]);

                return calcDate.format(`MMMM YYYY`);
            } else {
                return new Date().toLocaleString('default', { month: 'long' });
            }
        },
    }
}
</script>
